import React from 'react';

import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';
import LoadMenuTypes from 'bundle-loader?lazy&name=home!./routes/menu-types';
import LoadMenuTypeDetailsPage from 'bundle-loader?lazy&name=home!./routes/menu-type';
import LoadMenuTypeDefinition from 'bundle-loader?lazy&name=home!./routes/menu-type-definition';
import LoadSubmenuDefinition from 'bundle-loader?lazy&name=home!./routes/submenu-definition';
import LoadItemDefinition from 'bundle-loader?lazy&name=home!./routes/item-definition';

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Navigation Studio',
        pattern: '/',
        load: LoadHome,
        key: 'home'
    },
    {
        title: 'Menu Types',
        pattern: '/:companyId/menu-types',
        load: LoadMenuTypes,
        key: 'menu-types'
    },
    {
        title: 'Menu Type Details',
        pattern: '/:companyId/menu-types/edit/:menuType',
        load: LoadMenuTypeDetailsPage,
        key: 'edit-menu-type'
    },
    {
        title: 'Menu Type Details',
        pattern: '/:companyId/menu-types/create',
        load: LoadMenuTypeDetailsPage,
        key: 'create-menu-type'
    },
    {
        title: 'Menu Type Definitions',
        pattern: '/:companyId/menu-types/definition',
        load: LoadMenuTypes,
        key: 'menu-definition-list'
    },
    {
        title: 'Menu Type Definition',
        pattern: '/:companyId/menu-types/definition/:menuType',
        load: LoadMenuTypeDefinition,
        key: 'edit-menu-definition'
    },
    {
        title: 'Item Defintion',
        pattern: '/:companyId/menu-types/definition/:menuType/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-definition1'
    },
    {
        title: 'Submenu Defintion',
        pattern: '/:companyId/menu-types/definition/:menuType/submenu/:submenuName/:submenuId',
        load: LoadSubmenuDefinition,
        key: 'edit-submenu-definition1'
    },
    {
        title: 'Item Defintion',
        pattern: '/:companyId/menu-types/definition/:menuType/submenu/:submenuName/:submenuId/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-definition2'
    },
    {
        title: 'Submenu Defintion',
        pattern: '/:companyId/menu-types/definition/:menuType/submenu/:submenuName/:submenuId/submenu/:submenuName2/:submenuId2',
        load: LoadSubmenuDefinition,
        key: 'edit-submenu-definition2'
    },
    {
        title: 'Item Defintion',
        pattern: '/:companyId/menu-types/definition/:menuType/submenu/:submenuName/:submenuId/submenu/:submenuName2/:submenuId2/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-definition3'
    },
    {
        title: 'Menu Type Configurations',
        pattern: '/:companyId/menu-types/configuration',
        load: LoadMenuTypes,
        key: 'menu-configurations'
    },
    {
        title: 'Menu Type Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType',
        load: LoadMenuTypeDefinition,
        key: 'menu-configuration'
    },
    {
        title: 'Item Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-configuration1'
    },
    {
        title: 'Submenu Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType/submenu/:submenuName/:submenuId',
        load: LoadSubmenuDefinition,
        key: 'edit-submenu-configuration1'
    },
    {
        title: 'Item Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType/submenu/:submenuName/:submenuId/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-configuration2'
    },
    {
        title: 'Submenu Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType/submenu/:submenuName/:submenuId/submenu/:submenuName2/:submenuId2',
        load: LoadSubmenuDefinition,
        key: 'edit-submenu-configuration2'
    },
    {
        title: 'Item Configuration',
        pattern: '/:companyId/menu-types/configuration/:menuType/submenu/:submenuName/:submenuId/submenu/:submenuName2/:submenuId2/item/:itemName/:itemId',
        load: LoadItemDefinition,
        key: 'edit-item-configuration3'
    },
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;
    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}